import React, { useState } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';

const TidalDashboardWebhookAnalyticsTableWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  box-shadow: 0px 14px 29px rgba(0, 27, 31, 0.04);
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.background};
  padding: 0px 26px;
  height: 232px;
  max-height: 232px;
  overflow-y: auto;
  overflow-x: auto;
  max-width: 100%;
`;

const TidalDashboardWebhookAnalyticsTableTitle = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.colors.text[1]};
  margin-bottom: 15px;
`;

const TidalDashboardWebhookAnalyticsTableContainer = styled.table`
  text-align: right;
  position: relative;
  width: 100%;
  border: 0;
  border-collapse: separate;
  border-spacing: 0;
  tr,
  td {
    padding: 2px 5px;
    border-spacing: 0;
  }
  th {
    padding: 5px;
  }
  & > thead > tr > th {
    font-weight: 600;
    font-size: 14px;
    line-height: 32px;
    color: ${(props) => props.theme.colors.text[0]};
    position: sticky;
    top: 0;
    background-color: ${(props) => props.theme.colors.background};
    border-bottom: 1px solid ${(props) => props.theme.colors.borderColors[1]};
    border-collapse: separate;
  }
  & > thead > tr > th:nth-child(1) {
    text-align: left;
  }

  & > tbody > tr > td {
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
  }
  & > tbody > tr > td:nth-child(1) {
    text-align: left;
    min-width: 100px;
  }

  & > tbody > tr > td > tr > td > img {
    height: 21px;
    width: 21px;
    border-radius: 21px;
  }

  & > tbody > tr > td:nth-child(2) {
    color: ${(props) => props.theme.colors.accent};
  }

  & > tbody > tr > td:nth-child(3) {
    color: ${(props) => props.theme.colors.tags[0]};
  }

  & > tbody > tr > td:nth-child(4) {
    color: ${(props) => props.theme.colors.tags[4]};
  }
`;

interface TidalDashboardWebhookAnalyticsTableProps {
  columns: string[];
  data: any[];
  label: string;
}

const TidalDashboardWebhookAnalyticsTable = ({
  columns,
  data,
  label,
}: TidalDashboardWebhookAnalyticsTableProps): JSX.Element => {
  const [dataState, setDataState] = useState(data);
  useEffect(() => {
    setDataState(data);
  }, [data]);
  return (
    <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
      <TidalDashboardWebhookAnalyticsTableTitle>
        {label}
      </TidalDashboardWebhookAnalyticsTableTitle>
      <TidalDashboardWebhookAnalyticsTableWrapper>
        <TidalDashboardWebhookAnalyticsTableContainer>
          <thead>
            <tr>
              {columns.map((column: string, key: number) => {
                return <th key={key}>{column}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {dataState?.map((row: any, key: number) => {
              if (row)
                return (
                  <tr key={key}>
                    <td>
                      <tr>
                        {row?.image && row?.image.length > 0 && (
                          <td>{row.image && <img alt="" src={row.image} />}</td>
                        )}
                        <td>{row.name}</td>
                      </tr>
                    </td>
                    <td>{row.total}</td>
                    <td>{row.success}</td>
                    <td>{row.failed}</td>
                  </tr>
                );
            })}
          </tbody>
        </TidalDashboardWebhookAnalyticsTableContainer>
      </TidalDashboardWebhookAnalyticsTableWrapper>
    </div>
  );
};

export default TidalDashboardWebhookAnalyticsTable;
